import { createFileRoute, Link } from "@tanstack/react-router";
import { EsLiveRateSnapshot } from "@/components/rates/EsLiveRateSnapshot";
import { SiteShell, PageHero } from "@/components/site/SiteShell";
import { Section, SectionHeader, CTABand } from "@/components/site/Blocks";
import { buildHead } from "@/lib/seo-head";

export const Route = createFileRoute("/es/tasas-prestamos-dscr")({
  head: () =>
    buildHead({
      title: "Tasas de Préstamos DSCR | Simply Approved",
      description:
        "Cómo se determinan las tasas DSCR y qué factores afectan su cotización: DSCR, LTV, FICO, propiedad y propósito. Las cotizaciones son indicativas hasta la suscripción.",
      url: "/es/tasas-prestamos-dscr",
      locale: "es",
      keywords: "tasas préstamos DSCR, tasas inversión propiedad alquiler, factores tasa DSCR, cotización DSCR",
      breadcrumbs: [
        { name: "Inicio", url: "/es" },
        { name: "Tasas DSCR", url: "/es/tasas-prestamos-dscr" },
      ],
      service: { name: "Tasas y cotización de préstamos DSCR" },
    }),
  component: RatesPage,
});

function RatesPage() {
  return (
    <SiteShell>
      <PageHero eyebrow="Tasas DSCR" title="Cómo se forman las tasas de préstamos DSCR." subtitle="Las tasas DSCR no son de un solo tamaño. Se determinan por la combinación de factores de su escenario específico." />
      <Section>
        <SectionHeader title="Factores que determinan su tasa" center />
        <div className="mt-8 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {[
            { label: "DSCR", desc: "Relación renta/PITIA. DSCR más alto = riesgo menor = mejor precio." },
            { label: "LTV / préstamo", desc: "Menor apalancamiento generalmente significa mejor tasa y menor riesgo." },
            { label: "Puntaje FICO", desc: "El crédito del prestatario o entidad influye en el bucket de precios." },
            { label: "Tipo de propiedad", desc: "Unifamiliar, multifamiliar 2–4, condominio o unidades 5–8 tienen ajustes distintos." },
            { label: "Propósito", desc: "Compra, cash-out o rate-and-term refinanciamiento afectan el pricing." },
            { label: "Estructura de prepago", desc: "Puntos de compra, estructura de prepago y plazo también afectan la tasa." },
          ].map((f) => (
            <div key={f.label} className="rounded-2xl border border-border bg-card p-6">
              <h3 className="font-display text-lg font-bold text-foreground">{f.label}</h3>
              <p className="mt-2 text-sm text-muted-foreground">{f.desc}</p>
            </div>
          ))}
        </div>
        <EsLiveRateSnapshot />
      </Section>
      <CTABand title="Obtenga su cotización personalizada" body="Envíe su escenario para recibir tasas y términos reales." />
    </SiteShell>
  );
}
